module.exports = __webpack_public_path__ + "static/media/call.096f5f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/call.png
// module id = 1743
// module chunks = 0 1